import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "buggyfit-gmap buggyfit-gmap--courses",
  ref: "gmap"
}
const _hoisted_2 = {
  key: 0,
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseMarker = _resolveComponent("CourseMarker")!
  const _component_LocationMarker = _resolveComponent("LocationMarker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, null, 512),
    (_ctx.mapInitialized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesWithCoordinates, (course) => {
            return (_openBlock(), _createBlock(_component_CourseMarker, {
              key: course.id,
              google: _ctx.google,
              map: _ctx.map,
              course: course,
              lat: course.gathering_lat,
              lng: course.gathering_lng,
              onClick: () => _ctx.onCourseMarkerClick(course)
            }, null, 8, ["google", "map", "course", "lat", "lng", "onClick"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
            return (_openBlock(), _createBlock(_component_LocationMarker, {
              key: location.id,
              google: _ctx.google,
              map: _ctx.map,
              location: location,
              lat: location.lat,
              lng: location.lng
            }, null, 8, ["google", "map", "location", "lat", "lng"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}